import {Box} from "@mui/system";

export default function FacebookGifCard({ gifId }) {

    const url = `https://media1.tenor.co/m/${gifId}`;

    const addDefaultSrc = (ev) => {
        ev.target.src = '';
    };

    return(
        <Box>
            <img src={`${url}`}
                 onError={addDefaultSrc}
                 alt={'image'}
                 style={{...styles.image, ...{width: `300px`, maxWidth: `300px`}}}
            />
        </Box>
    )
}

const styles = {
    image: {
        borderRadius: '5px',
        border: '1px solid #C1C1C1'
    },
}